module.exports = __webpack_public_path__ + "img/aaa.7410be02.svg";